import { create } from 'zustand';
import type { SupportState } from './support.types';

export const defaultSupportState = {
  supportFacilities: null as any[] | null,
};

/**
 * Zustand store hook holding the support section state, seeded from the default support state. Exposes `setSupportFacilities`, which replaces the stored facility list with a shallow copy of the given array.
 *
 * @returns Hook that reads the support state and exposes its setters.
 */
const useSupportStore = create<SupportState>()((set) => ({
  ...defaultSupportState,
  setSupportFacilities: (supportFacilities) => set({ supportFacilities: [...supportFacilities] }),
}));

export default useSupportStore;
